import React from 'react';
import BillingPeriodClosureRowProperties from "./BillingPeriodClosureRowProperties";
import ViewMedium from "../../../ui_components/MediaView/ViewMedium";
import BillingPeriodClosureRowMedium from "./BillingPeriodClosureRowMedium";
import ViewLarge from "../../../ui_components/MediaView/ViewLarge";
import ViewSmall from "../../../ui_components/MediaView/ViewSmall";
import BillingPeriodClosureRowSmall from "./BillingPeriodClosureRowSmall";


const BillingPeriodClosureRow: React.FC<BillingPeriodClosureRowProperties> = ({
                                                      closure,
                                                      billingPeriodStatus,
                                                      billingPeriodStart,
                                                      billingPeriodEnd,
                                                      onUpdate = () => {
                                                      }
                                                  }) => {
    return (
        <>
            <ViewSmall>
                <BillingPeriodClosureRowSmall
                    billingPeriodStatus={billingPeriodStatus}
                    billingPeriodStart={billingPeriodStart}
                    billingPeriodEnd={billingPeriodEnd}
                    closure={closure}
                    onUpdate={onUpdate}
                />
            </ViewSmall>
            <ViewMedium>
                <BillingPeriodClosureRowMedium
                    billingPeriodStatus={billingPeriodStatus}
                    billingPeriodStart={billingPeriodStart}
                    billingPeriodEnd={billingPeriodEnd}
                    closure={closure}
                    onUpdate={onUpdate}
                />
            </ViewMedium>
            <ViewLarge>
                <BillingPeriodClosureRowMedium
                    billingPeriodStatus={billingPeriodStatus}
                    billingPeriodStart={billingPeriodStart}
                    billingPeriodEnd={billingPeriodEnd}
                    closure={closure}
                    onUpdate={onUpdate}
                />
            </ViewLarge>
        </>
    )
}

export default BillingPeriodClosureRow;
